<template>
    <div class="dropDownmenu-user trans-04 pos-fixed pb-5" v-if="rightSideBarOpened" :class="{'hide-dropDown-menu': opened}">
        <div class="right-sidebar-header pos-relative p-all-15 dis-flex flex-m flex-sb">
            <div class="dis-flex flex-m">
                <div class="avatar border-radius-lg shadow mr-3">
                    <img src="https://media.licdn.com/dms/image/v2/C5603AQF2SjGkLjhkzQ/profile-displayphoto-shrink_200_200/profile-displayphoto-shrink_200_200/0/1537805952777?e=2147483647&amp;v=beta&amp;t=fCdM-44rrRUji8jKvuY6xsBGrwzF7P0g__HHICiLkYo" alt="">
                </div>
                <div class="dis-flex flex-column">
                    <h6 class="font-h-6">{{ $store.state.myData.profileData.name }} {{ $store.state.myData.profileData.surname }}</h6>
                    <div class="dis-flex flex-m">
                        <span class="text-sm text-rose">Owner</span>
                        <i class="text-blue uil uil-signout fs-16 ml-3 pointer" title="Log out from Session " @click="unloginMeAsAdmin()"></i>
                    </div>
                </div>
            </div>
            <div class="sidebar-cat-icon-close dis-flex flex-m flex-c pointer" @click="opened = false">
                <div class="uim-svg fs-19">
                    <svg data-name="Layer 1" viewBox="0 0 24 24" width="1em">
                        <path class="uim-primary" d="M13.41,12l4.3-4.29a1,1,0,1,0-1.42-1.42L12,10.59,7.71,6.29A1,1,0,0,0,6.29,7.71L10.59,12l-4.3,4.29a1,1,0,0,0,0,1.41h0a1,1,0,0,0,1.41,0h0L12,13.41l4.29,4.3a1,1,0,0,0,1.41,0h0a1,1,0,0,0,0-1.42h0Z"></path>
                    </svg>
                </div>
            </div>
        </div>
        <div class="admin-sidebar-dropDownMenu-content">
            <div class="row flex-c mt-2">
                <div class="col-lg-12 p-lr-0-sm">
                    <div class="nav-wrapper pos-relative end-0">
                        <ul class="nav flex-sb" role="tablist">
                            <li class="nav-item pointer">
                                <a class="mb-0 px-0 py-1 active" data-bs-toggle="tab" role="tab">
                                    <button type="button" class="btn btn-element" @click="selectedMenu = 'actionsMenu'" :class="{'active-btn': selectedMenu == 'actionsMenu'}">
                                        <i class="uis uis-apps mr-2"></i>Actions
                                    </button>
                                </a>
                            </li>
                            <li class="nav-item pointer">
                                <a class="mb-0 px-0 py-1" data-bs-toggle="tab" role="tab">
                                    <button type="button" class="btn btn-element" @click="selectedMenu = 'profileMenu'" :class="{'active-btn': selectedMenu == 'profileMenu'}">
                                        <i class="uis uis-user mr-2"></i>Profile
                                    </button>
                                </a>
                            </li>
                            <li class="nav-item pointer">
                                <a class="mb-0 px-0 py-1" data-bs-toggle="tab" role="tab">
                                    <button type="button" class="btn btn-element" @click="selectedMenu = 'settingsMenu'" :class="{'active-btn': selectedMenu == 'settingsMenu'}">
                                        <i class="uis uis-setting mr-2"></i>Settings
                                    </button>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="content-crds-messages-scroll mt-4 pb-5" v-if="selectedMenu == 'actionsMenu'">
                <actions-menu></actions-menu>
            </div>

            <div v-if="selectedMenu == 'settingsMenu'">
                <my-settings></my-settings>
            </div>
            <div v-if="selectedMenu == 'profileMenu'">
                <my-profile></my-profile>
            </div>
        </div>
    </div>
</template>

<script>
import myProfileVue from "./rightUserSideBar/myProfile.vue";
import mySettingsVue from "./rightUserSideBar/mySettings.vue";
import actionsMenuVue from "./rightUserSideBar/actionsMenu.vue";

import thisLogoutMixin from "@/mixins/logoutMixin";

export default {
    mixins: [thisLogoutMixin],
    components: {
        myProfile: myProfileVue,
        mySettings: mySettingsVue,
        actionsMenu: actionsMenuVue
    },
    data() {
        return {
            rightSideBarOpened: false,
            opened: false,
            selectedMenu: 'actionsMenu'
        }
    },
    watch: {
        'rightSideBarOpened': function(newValue, oldValue) {
            setTimeout(() => {
                this.opened = newValue
            }, 100);
        },
        'opened': function(newValue, oldValue) {
            if (this.rightSideBarOpened != newValue) {
                setTimeout(() => {
                    this.rightSideBarOpened = newValue
                }, 400);
            }

            if (newValue && device.type === 'mobile') {
                $('html').addClass('overf-hidden');
                $('body').addClass('overf-hidden');
            } else if (!newValue && device.type === 'mobile') {
                $('html').removeClass('overf-hidden');
                $('body').removeClass('overf-hidden');
            }
        }
    }
}
</script>

<style>

</style>